export enum Scene7Paths {
    IMAGE = 'https://images.kwikset.com/is/image/',
	CONTENT = 'https://s7d2.scene7.com/is/content/'
}

export enum Scene7Repos {
	KWIKSET = 'Kwikset',
	BDHHI = 'BDHHI',
	WEBASSETS = 'WebAssets'
}

export class Scene7Helper {
	static splitPath(path: string) {
		if (path == null) { path = ''; }
		let imageId: string = path, repo: string = Scene7Repos.KWIKSET;

		if (path.indexOf('/') > -1) {
			[repo, imageId] = path.split('/');
		}

		if (!imageId) { imageId = 'null; '}

		return {
			repo: repo,
			imageId: imageId
		}
	}

	static imagePath(imageID: string, repo?: string, size?: string, additionalParams?: string): string {
		if (!repo) { repo = Scene7Repos.KWIKSET; }
		let preset = size != null ? `?$${size}$` : '';
		let params = additionalParams ? `&${additionalParams}`: '';
		return `${Scene7Paths.IMAGE}${repo}/${imageID}${preset}${params}`;
	}

	static imagePathNoPreset(imageID: string, repo?: string, additionalParams?: string): string {
		if (!repo) { repo = Scene7Repos.KWIKSET; }
		let params = additionalParams ? `${additionalParams}`: '';
		return `${Scene7Paths.IMAGE}${repo}/${imageID}${params}`;
	}

	static contentPath(contentID: string, repo?: string): string {
		if (!repo) { repo = Scene7Repos.KWIKSET; }
		return `${Scene7Paths.CONTENT}${repo}/${contentID}`;
	}
}



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/helpers/scene7.helper.ts